module.exports = __webpack_public_path__ + "img/message-shape.f0fcd54a.svg";